import { CircularProgress, css, FormControl, IconButton, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { Fragment, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useSessionStore } from 'session/useSessionStore';
import { useSeismicStore } from '../stores/useSeismicStore';
import { IColorbar } from '../models/interfaces/IColorbar';
import { useAPI } from 'hooks/useAPI';
import { useMapStore } from '../stores/useMapStore';
import { Colorbar } from '../utils/colorbarUtils';

const style = css({
    maxWidth: '10rem',
});

const itemStyle = css({
    display: 'flex',
    flexDirection: 'row',
    fontSize: '14px',
    alignItems: 'center',

    '& .label': {
        marginLeft: 8,
        color: '#ffffff'
    }
});

const imageStyle = css({
    height: '1rem',
    width: '1rem'
});

export type SeismicColorbarSelectProps = {
    colorbar: IColorbar,
    onChange: (value: IColorbar) => void,
    additionalColorbars?: IColorbar[],
    disabled?: boolean,
};

export function SeismicColorbarSelect ({ colorbar, onChange, additionalColorbars = [], disabled = false} : SeismicColorbarSelectProps) {

    // const { isLoading, execute, data } = useAPI<IColorbar[]>('/Seismic/Colorbar/Available');

    const colorbars = useMemo<IColorbar[]>(() => {
        const staticColors : IColorbar[] = [
            Colorbar.BINARY,
            Colorbar.RWB,
            Colorbar.RWG,
            ...additionalColorbars
        ];
        return staticColors;
    }, [additionalColorbars]);

    const { setBackgroundColor } = useMapStore(state => ({
        setBackgroundColor: state.setBackgroundColor
    }));

    const { tenantConfig } = useSessionStore(state => ({
        tenantConfig: state.tenantConfiguration,
    }));

    const [loadedDefault, setLoadedDefault] = useState(false);

    useEffect(() => {
        if (tenantConfig && !loadedDefault) {
            selectDefaultByTenant();
        }
    }, [tenantConfig]);

    const handleChange = (event: SelectChangeEvent) => {
        const tokenSelected = event.target.value as string;
        const colorBar = colorbars?.find(x => x.Token === tokenSelected);

        if (colorBar) {
            onChange(colorBar);
        }
    };

    const selectDefaultByTenant = () => {
        const nameDefault = tenantConfig?.viewer2DDefaults?.color_bar_name;
        const colorBar = colorbars?.find(x => x.Name.toLowerCase() === nameDefault?.toLowerCase());

        if (colorBar){
            onChange(colorBar);
        }

        setLoadedDefault(true);
    };

    return (
        <Fragment>
            <FormControl fullWidth css={style}>
                <Select
                    disabled={disabled}
                    defaultValue='976eba63-1a53-42a6-9e85-46049d8886f8'
                    value={colorbar?.Token}
                    onChange={handleChange}
                    style={{ fontSize: '14px'}}
                >
                    {colorbars && colorbars.map(colorbar => (
                        <MenuItem value={colorbar.Token} key={colorbar.Token} >
                            <div className='item' css={itemStyle}>
                                <img className='image' src={colorbar.Picture} css={imageStyle}/>
                                <span className='label'>{colorbar.Label}</span>
                            </div>
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Fragment>
    );
}